// @flow
import React, { FunctionComponent, useCallback, useState } from 'react';
import styled from 'styled-components';
import FileSaver from 'file-saver';
import Spinner from '@atlaskit/spinner';
import ExportIcon from '@atlaskit/icon/glyph/export';
import Button from '@atlaskit/button';
import { withApollo, WithApolloClient } from 'react-apollo';
import { analytics } from '../../services/analytics';
import { EXPORT_VIRTUAL_COMPONENTS_QUERY } from '../../graphql/queries';

const StyledCsv = styled.div`
    pointer-events: 'auto';
`;

const headers = ['"Component"', '"Description"', '"Projects"', '"Component lead"', '"Default assignee"'];

const convertToRowData = (component, delimiter) => {
    const projectsNames = (component.projects || []).map(({ jiraProjectName }) => jiraProjectName).join(', ');
    return [
        `"${component.name}"`,
        `"${component.description || ''}"`,
        `"${projectsNames}"`,
        `"${component.virtualComponentLead?.jiraUserDisplayName || ''}"`,
        `"${component.assigneeType || ''}"`,
    ].join(delimiter);
};
const ExportCSVButton: FunctionComponent<WithApolloClient> = ({ client, searchRef, delimiter = ',' }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const onClickExport = useCallback(() => {
        setLoading(true);
        const { pagination, ...variables } = searchRef.current;
        client
            .query({ query: EXPORT_VIRTUAL_COMPONENTS_QUERY, fetchPolicy: 'network-only', variables })
            .then(({ data }) => {
                const rows = data.findAllVirtualComponents.map((row) => convertToRowData(row, delimiter));
                const content = [headers.join(delimiter), ...rows].join('\n');
                const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
                FileSaver.saveAs(blob, 'components-list.csv');
            })
            .finally(() => setLoading(false));
        analytics.track({
            userId: window.license,
            event: 'export_csv',
            timestamp: new Date(),
            properties: {
                addon_key: process.env.REACT_APP_KEY,
            },
        });
    }, [client, delimiter, searchRef]);
    return (
        <StyledCsv>
            <Button
                appearance="subtle"
                onClick={onClickExport}
                iconBefore={loading ? <Spinner size="small" /> : <ExportIcon label="export" />}
                isDisabled={loading}
            >
                Export
            </Button>
        </StyledCsv>
    );
};

export default withApollo(ExportCSVButton);
